import {createSlice} from '@reduxjs/toolkit';
import {
    getUserActiveNotificationsFailure,
    getUserActiveNotificationsRequest,
    getUserActiveNotificationsSuccess,
} from 'src/openapi/admin/apis/UserInternalNotificationApi';

import type {Notification} from 'src/openapi/admin/models/Notification';
import type {AppState} from 'src/store/typedef';
import type {ServerResponse} from 'src/typedef';

type InitialState = {
    isLoading: boolean,
    activeNotification: ServerResponse<Notification[]> | null,
};

const initialState: InitialState = {
    isLoading: false,
    activeNotification: null,
};

export const userNotificationsSlice = createSlice({
    name: 'userNotifications',
    initialState,
    reducers: {},
    extraReducers: builder => builder
        .addCase(getUserActiveNotificationsRequest, state => {
            state.isLoading = true;
            state.activeNotification = null;
        })
        .addCase(getUserActiveNotificationsSuccess, (state, action) => {
            state.isLoading = false;
            state.activeNotification = {data: action.payload.data};
        })
        .addCase(getUserActiveNotificationsFailure, (state, action) => {
            state.isLoading = false;
            state.activeNotification = {error: action.payload.data};
        }),
});

export const activeNotificationsSelector = (state: AppState) =>
    state.internalNotification.userNotifications.activeNotification;
